import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { allProducts } from '@/utils/productsData';

type CategoryType = 'indoor' | 'outdoor' | 'square' | 'accessories';

const categories = [
  { id: 'indoor' as CategoryType, label: 'Indoor' },
  { id: 'outdoor' as CategoryType, label: 'Outdoor' },
  { id: 'square' as CategoryType, label: 'Square' },
  { id: 'accessories' as CategoryType, label: 'アクセサリー' },
];

export const ProductLineup: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<CategoryType>('indoor');

  useEffect(() => {
    // URLハッシュからカテゴリを読み取る
    const handleHashChange = () => {
      const hash = window.location.hash;
      console.log('[ProductLineup] Current hash:', hash);
      const match = hash.match(/#lineup-(\w+)/);
      console.log('[ProductLineup] Match result:', match);
      if (match && match[1]) {
        const category = match[1] as CategoryType;
        console.log('[ProductLineup] Detected category:', category);
        if (['indoor', 'outdoor', 'square', 'accessories'].includes(category)) {
          console.log('[ProductLineup] Setting active category to:', category);
          setActiveCategory(category);
        }
      }
    };

    // 初期読み込み時
    handleHashChange();

    // ハッシュ変更を監視
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const handleCategoryClick = (categoryId: CategoryType) => {
    setActiveCategory(categoryId);
  };

  return (
    <section id="lineup" className="lineup">
      <div className="container">
        <h2 className="section-title">製品ラインナップ</h2>
        <div className="lineup-categories">
          <div className="category-tabs">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`tab-button ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category.id)}
              >
                {category.label}
              </button>
            ))}
          </div>

          <div className="category-content active">
            <div className="products-grid">
              {allProducts[activeCategory].map((product) => (
                <Link
                  key={product.id}
                  to={`/product/${product.id}`}
                  className="product-card"
                >
                  <div className="product-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="product-info">
                    <h4>{product.name}</h4>
                    <p className="product-size">{product.size}</p>
                    <p className="product-desc">{product.description}</p>
                    <div className="product-specs-mini">
                      <span>{product.specs.brightness}</span>
                      <span>{product.specs.weight}</span>
                      <span>{product.specs.thickness}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
